import renderElement from './element';

export default renderElement.bind(null, 'pre');




// WEBPACK FOOTER //
// ../~/idom-util/src/pre.js